<template>
	<b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
		<b-row>
			<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
				<label class="sa-label-data">Nome:</label>
				<b-form-input v-model="jsonData.nome"></b-form-input>
			</b-col>
			<b-col cols="12" xs="12" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Tipo:</label>
				<!-- <b-form-input v-model="jsonDataSpeseExtra.naturaEconomica"></b-form-input> -->
				<b-form-select v-model="jsonData.tipoAttivita" :options="tipoAttivitaOptions" :value="''" value-field="descrizione" text-field="descrizione">
					<template #first>
						<b-form-select-option :value="null" disabled> - Seleziona Attivita - </b-form-select-option>
					</template>
				</b-form-select>
			</b-col>
			<b-col cols="12" xs="12" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Priorità:</label>
				<!-- <b-form-input v-model="jsonDataSpeseExtra.naturaEconomica"></b-form-input> -->
				<b-form-select v-model="jsonData.codicePriorita" :options="tipoPrioritaOptions" :value="''" value-field="codice" text-field="descrizione">
					<template #first>
						<b-form-select-option :value="null" disabled> - Seleziona Priorita - </b-form-select-option>
					</template>
				</b-form-select>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
				<label class="sa-label-data">Data Inizio:</label>
				<date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataOraInizio" type="date"></date-picker>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
				<label class="sa-label-data">Data Fine:</label>
				<date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataOraFine" type="date"></date-picker>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Descrizione:</label>
				<b-form-textarea v-model="jsonData.descrizione" rows="7"></b-form-textarea>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Note:</label>
				<b-form-textarea v-model="jsonData.note" rows="7"></b-form-textarea>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../utility/UtilityMixin";
import GestioneAttivitaTipiAttivitaMixin from "../mixinis/GestioneAttivitaTipiAttivitaMixin";
export default {
	mixins: [UtilityMixin, GestioneAttivitaTipiAttivitaMixin],
	components: { DatePicker },
	data() {
		return {
			id: null,
			pathResourcePriorita: "/gestioneattivitapriorita",
			pathResource: "/gestioneattivitaattivita",
			tipoAttivitaOptions: [],
			tipoPrioritaOptions: [],
			jsonData: { descrizione: "", tipoAttivita: null, dataOraInizio: null, dataOraFine: null, codicePriorita: null },
		};
	},
	mounted() {
		this.loadAttivitaTipi();
		this.loadDataPriorita();
		this.id = this.$route.params.id;
		if (this.id !== "-1") {
			this.loadData();
		}
	},
	watch: {
		jsonData: {
			handler(jsonData) {
				this.$emit("updateJsonData", jsonData);
			},
			deep: true,
		},
	},
	methods: {
		loadDataPriorita() {
			let me = this;
			UtilityMixin.methods.loadDataResources(me.pathResourcePriorita, {}, me.loadDataPrioritaSuccess, me.loadDataError);
		},
		loadDataPrioritaSuccess(resposne) {
			let me = this;
			me.tipoPrioritaOptions = resposne.data.data.list;
		},

		loadData() {
			let me = this;
			me.$emit("beforeLoadData");
			UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.jsonData = response.data.data;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
	},
};
</script>

<style></style>
